import { MarketGraphDataStatuses } from 'constants/marketGraph';
import { BettingTypes } from 'constants/markets';
import { AppState } from 'redux/reducers';

export const getMarketGraphChartDataPoints = ({ marketGraph }: AppState) => marketGraph.chartData.points;

export const getMarketGraphChartIsLoading = ({ marketGraph }: AppState) =>
  marketGraph.chartData.status === MarketGraphDataStatuses.pending;

export const getMarketGraphChartIsUpdated = ({ marketGraph }: AppState) =>
  marketGraph.chartData.status === MarketGraphDataStatuses.updated;

export const getMarketGraphChartIsData = ({ marketGraph }: AppState) => {
  return (
    marketGraph.chartData.status !== MarketGraphDataStatuses.pending &&
    marketGraph.chartData.status !== MarketGraphDataStatuses.noData &&
    marketGraph.chartData.points.length
  );
};

export const getGraphMarketLoading = ({ marketGraph }: AppState) => marketGraph.marketLoading;
export const getGraphMarketInfo = ({ marketGraph }: AppState) => marketGraph.market;
export const getGraphCurrentSelection = ({ marketGraph }: AppState) => marketGraph.currentSelection;
export const getGraphMarketEntries = ({ marketGraph }: AppState) => marketGraph.market?.entries;
export const getGraphMarketBettingType = ({ marketGraph }: AppState) =>
  marketGraph.marketData?.marketDefinition.bettingType;
export const getGraphMarketEventTypeId = ({ marketGraph }: AppState) =>
  marketGraph.marketData?.marketDefinition.eventTypeId;
export const getGraphMarketCurrency = ({ marketGraph }: AppState) => marketGraph.marketData?.currency;
export const getGraphMarketMatchedAmount = ({ marketGraph }: AppState) => marketGraph.marketData?.tv;
export const getGraphMarketLastTradedPrice = ({ marketGraph }: AppState) => marketGraph.marketData?.rc?.[0].ltp;
export const getGraphMarketMinPrice = ({ marketGraph }: AppState) => marketGraph.marketData?.minPrice;
export const getGraphMarketMaxPrice = ({ marketGraph }: AppState) => marketGraph.marketData?.maxPrice;
export const getGraphSelectionMatchedAmount = ({ marketGraph }: AppState) => marketGraph.marketData?.totalMatched;
export const getActiveMarkets = ({ marketGraph }: AppState) => marketGraph.activeMarkets;
export const getMarketGraphMarketStartTime = ({ marketGraph }: AppState) => marketGraph.market?.startTime;
export const getMarketGraphChartUpdatedPoints = ({ marketGraph }: AppState) => marketGraph.chartUpdatedPoints;
export const getLiquidityTradedTable = ({ marketGraph }: AppState) => marketGraph.liquidityTradedTable;
export const getIsMarketDataLoaded = ({ marketGraph }: AppState) => marketGraph.isMarketDataLoaded;
export const getGraphMarketDisabledLayOdds = ({ marketGraph }: AppState) => marketGraph.marketData?.disabledLayOdds;
export const getGraphMarketBestBack = ({ marketGraph }: AppState) => marketGraph.bestBack;
export const getMarketGraphIsMarketBettingType = ({ marketGraph }: AppState) =>
  marketGraph.marketData?.marketDefinition.bettingType === BettingTypes.LINE;
export const getMarketGraphIsMarketError = ({ marketGraph }: AppState) => !!marketGraph.marketError;
export const getGraphMarketIsFancy = ({ marketGraph }: AppState) => !!marketGraph.market?.fancy;
